import Container from "layouts/container/Container";
import style from "./TopBar.module.css";
import TopBarItem from "./TopBarItem";
import { useTranslation } from "react-i18next";
import TopBarSubItem from "./TopBarSubItem";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import flag_korea from "resources/img/flag_korea.png";
import flag_china from "resources/img/flag_china.png";
import DesktopLanguageSwitcher from "components/countryFlag/DesktopLanguageSwitcher";
import { AuthContext } from "providers/AuthProvider";
import { useContext } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { OrderInfoReducer } from "shared/redux/reducers/shopping/OrderInfoReducer";
import { WishReducer } from "shared/redux/reducers/shopping/WishReducer";
import { DirectPurchaseReducer } from "shared/redux/reducers/shopping/DirectPurchaseReducer";
import { SearchConditionReducer } from "shared/redux/reducers/product/SearchConditionReducer";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { useDispatch } from "react-redux";
import { removeLocalStorage } from "shared/utils/Utils";
import { useNavigate, useParams } from "react-router-dom";
import logo from "resources/img/logo.png";
import FlexChild from "layouts/flex/FlexChild";

function TopBar() {
  const { userName } = useContext(AuthContext);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const onLogoutClick = () => {
    NiceModal.show("logout", {
      message: t("confirmLogout"),
      confirmText: t("confirm"),
      cancelText: t("cancel"),
      onConfirm: onConfirm,
      onCancel: onCancel
    });
  }

  const onConfirm = () => {
    removeLocalStorage("token");
    dispatch(AuthReducer.actions.reset());
    dispatch(CartReducer.actions.reset());
    dispatch(OrderInfoReducer.actions.reset());

    dispatch(DirectPurchaseReducer.actions.reset());
    dispatch(SearchConditionReducer.actions.reset());
    dispatch(HistoryReducer.actions.reset());
    window.location.href = `/ws/${id}/homepage`;
  }
  const onCancel = () => {

  }
  const onHomeBtnClick = () => {
    navigate(`/ws/${id}/homepage`, { state: { selectedCategory: "" } });
  }

  return (
    <Container height={40} backgroundColor={"#fafafa"}>
      <Container maxWidth={1200} padding={"0 0 0 10px"}>

        <img src={logo} width={"15%"} height={"38px"} style={{ padding: "5px", cursor: "pointer" }} onClick={onHomeBtnClick} />

        <ul className={style.columns}>
          {/* <li className={style.column}>
            <DesktopLanguageSwitcher />
          </li> */}

          {/* <TopBarItem title={t("vendorMenu")} >
            <TopBarSubItem title={t("vendorSignUp")} url={"/vendorRegister"} />
            <TopBarSubItem title={t("vendorSignIn")} url={"/vendorSignIn"} />
          </TopBarItem> */}
          {/* <TopBarItem icon={faHeart} title={t("wishList")} url={"/wishlist"} /> */}
          {
            userName && <TopBarItem icon={faUser} title={t("mypage")} url={`/ws/${id}/homepage/mypage`} />
          }
          {
            userName && <TopBarItem title={t("cart")} url={`/ws/${id}/homepage/cart`} />
          }
          {
            !userName ? <TopBarItem title={t("signIn")} url={`/ws/${id}/homepage/login`} /> : <TopBarItem title={t("signOut")} onClick={onLogoutClick} />
          }
          {/* <TopBarItem icon={faUser} title={t("account")}>
            <TopBarSubItem title={t("orderHistory")} url={"/mypage"} /> */}
          {/* <TopBarSubItem title={t("message")} url={"/user/message"} /> */}
          {/* <TopBarSubItem title={t("wishList")} url={"/wishlist"} /> */}
          {/* <TopBarSubItem title={t("FAQ")} url={"/faq"} /> */}
          {/* <TopBarSubItem title={t("inquiry")} url={"/singleInquiry"} /> */}
          {/* <TopBarSubItem title={t("공지사항")} url={"/notice"} /> */}
          {/* </TopBarItem> */}
        </ul>
      </Container>
    </Container>
  );
}

export default TopBar;
